import { Component, OnInit } from '@angular/core'
import { RouterModule, RouterOutlet } from '@angular/router'
import { LoaderComponent } from './components/loader/loader.component'
import { fetchAuthSession } from 'aws-amplify/auth'
import { UserActiveService } from './services/user-active.service'
import { GtmTrackingService } from './services/gtm-tracking.service'
import { DashboardComponent } from './modules/dashboard/dashboard.component'
import { OneTrustService } from './common/services/one-trust.service'
import { setUtminSession, setItmParamsInStorage } from './common/utilities/utm-params-utils'
import { UserAuthService } from './services/user-auth.service'
@Component({
    selector: 'app-root',
    imports: [RouterOutlet, LoaderComponent, RouterModule],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  applyBodyContentClass: boolean = true

  constructor (private inactiveService: UserActiveService, private gtmService: GtmTrackingService,
    private oneTrustService: OneTrustService, private authService: UserAuthService) {
    this.gtmService.waitForGaUserId().subscribe({
      next: () => {
        this.gtmService.setOrGetClientTracking()
        this.oneTrustService.denyGrantGATag()
      }
    })
    this.checkUserSession()
    this.authService.syncCognitoSession()
  }

  ngOnInit () {
    setUtminSession()
    setItmParamsInStorage()
  }

  onRouterOutletActivate (componentInstance: any): void {
    if (componentInstance instanceof DashboardComponent) {
      this.applyBodyContentClass = false
    } else {
      this.applyBodyContentClass = true
    }
  }
  onRouterOutletDeactivate (componentInstance: any): void {
    if (componentInstance instanceof DashboardComponent) {
      this.applyBodyContentClass = true
    }
  }
  async checkUserSession () {
    const session = await fetchAuthSession()
    if (session?.tokens?.idToken) {
      this.inactiveService.userLoggedIn()
    }
  }
}
